import { useEffect } from "react";
export const useDocumentTitle = (title) => {

    useEffect(() => {
        document.title = `${title} - Kate the Chemist`;
    }, [title]);

    return null;
}